import { Tag20Filled } from '@fluentui/react-icons';
import { darkModeColorHexValuesMap, defaultColorValue, lightModeColorHexValuesMap, } from '@office-start/tagging-types';
import { useIsDarkMode } from '@office-start/theming-service';
import React, { useMemo } from 'react';
import styles from './TagItemControl.module.scss';
export var TagItemControl = function (_a) {
    var tagItem = _a.tagItem, maxWidth = _a.maxWidth;
    var isDarkMode = useIsDarkMode();
    var tagNameMaxWidth = useMemo(function () {
        return maxWidth
            ? maxWidth - 30 /* 20px for icon, 10px for padding */
            : undefined;
    }, [maxWidth]);
    var hexColor = useMemo(function () {
        var colorMap = isDarkMode
            ? darkModeColorHexValuesMap
            : lightModeColorHexValuesMap;
        return colorMap.get(tagItem.color || defaultColorValue);
    }, [isDarkMode, tagItem.color]);
    return (React.createElement("div", { className: styles.root },
        React.createElement(Tag20Filled, { primaryFill: "#".concat(hexColor), className: styles.tagIcon }),
        React.createElement("span", { className: styles.tagContent, style: tagNameMaxWidth ? { maxWidth: tagNameMaxWidth } : undefined }, tagItem.value)));
};
//# sourceMappingURL=TagItemControl.js.map